// extracted by mini-css-extract-plugin
export default {"loadingScreen":"CommuLinoLoading_loadingScreen__bY1L+","logo":"CommuLinoLoading_logo__eBm+M","activeColor":"CommuLinoLoading_activeColor__OT3Pr"};